import { render, staticRenderFns } from "./trips-synthetic.vue?vue&type=template&id=62c2df26&"
import script from "./trips-synthetic.vue.js?vue&type=script&lang=js&"
export * from "./trips-synthetic.vue.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports